/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { Link } from "react-router-dom";
import helper from "../helper/helper";
import { authService } from "../module/public/auth/service/auth.service";

export interface Menu {
  icon?: string;
  text: string;
  path?: string;
  roles?: string[];
  children?: Menu[];
}

function Sidebar() {
  const user = helper.getUser();
  const [selectedMenuIndex, setSelectedMenuIndex] = useState(0);
  let menus: Menu[] = [
    {
      text: "Хэрэглэгчид",
      icon: "icon-users2",
      path: "/users",
      roles: ["user-full", "user-manage", "user-read"],
    },
    {
      text: "Харилцагчид",
      icon: "icon-office",
      path: "/customers",
      roles: ["customer-full", "customer-read"],
    },
    {
      text: "Бүтээгдэхүүнүүд",
      icon: "icon-box",
      path: "/products",
      roles: ["product-full", "product-read"],
    },
    {
      text: "Төлөвлөгөө",
      icon: "icon-list-unordered",
      children: [
        {
          text: "Төлөвлөгөөний жагсаалт",
          path: "/plans",
          roles: ["plan-full", "plan-read"],
        },
        {
          text: "Харилцагчийн төлөвлөгөө",
          path: "/plans/customer/add",
          roles: ["plan-full"],
        },
      ],
    },
    {
      text: "Даалгаварууд",
      icon: "icon-pencil7",
      children: [
        {
          text: "Өрөлт болон борлуулалт",
          path: "/tasks",
          roles: ["task-full", "task-read"],
        },
        {
          text: "Оноосон ажил",
          path: "/assignments",
          roles: ["task-full", "task-read"],
        },
      ],
    },
    {
      text: "Промошнууд",
      icon: "icon-price-tags",
      path: "/promotions",
      roles: ["promotion-full", "promotion-read"],
    },
    {
      text: "Хэрэглэгч хүсэлтүүд",
      icon: "icon-users4",
      path: "/customer/requests",
      roles: [
        "customer-request-full",
        "customer-request-read",
        "customer-request-read-delete",
        "customer-request-read-update",
      ],
    },
    {
      text: "Документ",
      icon: "icon-magazine",
      path: "/documents",
      roles: ["document-full"],
    },
    {
      text: "Тохиргоо",
      icon: "icon-wrench",
      children: [
        {
          text: "Брэнд",
          path: "/brand",
          roles: ["task-full", "task-read"],
        },
        {
          text: "Төрөл",
          path: "/category",
          roles: ["task-full", "task-read"],
        },
      ],
    },
  ];

  const getMenu = (_menu: Menu, roles: string[]) => {
    if (_menu.roles && roles) {
      for (const _role of _menu.roles) {
        if (roles.includes(_role)) {
          return true;
        }
      }

      return false;
    } else {
      return true;
    }
  };

  const getMenus = () => {
    let roles: string[] = helper.getRoles();

    if (roles.length === 0) {
      authService.logout();
    }

    menus = menus.filter((_menu) => {
      _menu.children = _menu.children?.filter((_child) => {
        return getMenu(_child, roles);
      });

      return getMenu(_menu, roles);
    });

    return menus.map((menu, index) => (
      <li
        className={`nav-item ${menu.children ? "nav-item-submenu" : ""}`}
        key={index}
      >
        <Link
          to={menu.children ? "#" : menu.path!}
          className={`nav-link ${index === selectedMenuIndex ? "active" : ""}`}
          onClick={() => setSelectedMenuIndex(index)}
        >
          <i className={menu.icon} />
          <span>{menu.text}</span>
        </Link>
        {menu.children && (
          <ul className="nav nav-group-sub">
            {menu.children.map((_menu) => {
              return (
                <Link to={_menu.path!} key={_menu.path} className="nav-item">
                  <a className="nav-link">{_menu.text}</a>
                </Link>
              );
            })}
          </ul>
        )}
      </li>
    ));
  };

  return (
    <div className="sidebar sidebar-light sidebar-main sidebar-expand-md">
      <div className="sidebar-mobile-toggler text-center">
        <a href="#" className="sidebar-mobile-main-toggle">
          <i className="icon-arrow-left8" />
        </a>
        Цэс
        <a href="#" className="sidebar-mobile-expand">
          <i className="icon-screen-full" />
          <i className="icon-screen-normal" />
        </a>
      </div>
      <div className="sidebar-content">
        <div className="sidebar-user">
          <div className="card-body">
            <div className="media">
              <div className="mr-3">
                <a href="#">
                  <img
                    src="/assets/limitless/global_assets/images/placeholders/placeholder.jpg"
                    width={38}
                    height={38}
                    className="rounded-circle"
                    alt=""
                  />
                </a>
              </div>
              <div className="media-body">
                <div className="media-title font-weight-semibold">
                  {helper.getUserFullName(user)}
                </div>
                <div className="font-size-xs opacity-50">
                  <i className="icon-user font-size-sm" /> &nbsp;Админ
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card card-sidebar-mobile">
          <ul className="nav nav-sidebar" data-nav-type="accordion">
            <li className="nav-item-header">
              <div className="text-uppercase font-size-xs line-height-xs">
                Цэс
              </div>{" "}
              <i className="icon-menu" title="Цэс" />
            </li>
            {getMenus()}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
